import React from 'react';
import Slider from 'react-slick';
import ImageWithBasePath from '../../core/common/imageWithBasePath';
import { Link } from 'react-router-dom';
import { all_routes } from '../router/all_routes';
import { redirectLinks } from '../router/redirectLinks';

const SearchBy = () => {
  const routes = all_routes;

  // ✅ Destination data object
  const destinations = [
    {
      name: 'Azerbaijan',
      image: 'assets/img/destination/azerbaijan.jpg',
      link: redirectLinks.azerbaijan,
    },
    {
      name: 'Georgia',
      image: 'assets/img/destination/Georgia.jpg',
      link: redirectLinks.georgia,
    },
    {
      name: 'Hongkong - Macau',
      image: 'assets/img/destination/hongkong - macau.jpg',
      link: redirectLinks.hongkongMacau,
    },
    {
      name: 'Indonesia Bali',
      image: 'assets/img/destination/baliindonesia.jpg',
      link: redirectLinks.indonesiaBali,
    },
    {
      name: 'Israel Jordan',
      image: 'assets/img/destination/israel.jpg',
      link: redirectLinks.israelJordan,
    },
    {
      name: 'Philippines',
      image: 'assets/img/destination/philippines.jpg',
      link: redirectLinks.philippines,
    },
    {
      name: 'Vietnam',
      image: 'assets/img/destination/vietnam.jpg',
      link: redirectLinks.vietnam,
    },
  ];

  // ✅ Custom Arrows
  const CustomNextArrow = ({ onClick }: any) => (
    <div className="owl-nav">
      <button type="button" role="presentation" className="owl-next" onClick={onClick}>
        <i className="fa-solid fa-chevron-right" />
      </button>
    </div>
  );

  const CustomPrevArrow = ({ onClick }: any) => (
    <div className="owl-nav">
      <button type="button" role="presentation" className="owl-prev" onClick={onClick}>
        <i className="fa-solid fa-chevron-left" />
      </button>
    </div>
  );

  // ✅ Slider configuration
  const ProviderSlick = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 576, settings: { slidesToShow: 2 } },
      { breakpoint: 0, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="section destination-section blog-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-10 text-center aos" data-aos="fade-up">
            <div className="section-header text-center">
              <h2 className="mb-2">
                Search by{' '}
                <span className="text-primary text-decoration-underline">Destinations</span>{' '}
                Around the World
              </h2>
              <p className="sub-title">
                Trio International is a platform designed to connect people with
                exclusive experiences related to a specific tour.
              </p>
            </div>
          </div>
        </div>

        {/* ✅ Loop through destinations */}
        <Slider {...ProviderSlick} className="owl-carousel destination-slider nav-center">
          {destinations.map((item, index) => (
            <div
              key={index}
              className="destination-item mb-4 aos"
              data-aos="fade-up"
            >
              <ImageWithBasePath src={item.image} alt={item.name} />
              <div className="destination-info text-center">
                <div className="destination-content">
                  <h5 className="mb-1 text-white">{item.name}</h5>
                </div>
              </div>
              <Link to={item.link} className="overlay-circle-link">
                <i className="isax isax-arrow-right-1" />
              </Link>
            </div>
          ))}
        </Slider>

        {/* <div className="text-center view-all aos" data-aos="fade-up">
          <Link
            to={routes.destination}
            className="btn btn-dark d-inline-flex align-items-center"
          >
            View All Locations
            <i className="isax isax-arrow-right-3 ms-2" />
          </Link>
        </div> */}
      </div>
    </section>
  );
};

export default SearchBy;